import { startTransition, useEffect, useEffectEvent, useRef } from 'react';
import { useBreadcrumbContext } from './BreadCrumbsContext';
import { BreadCrumb } from './types';

interface BreadcrumbsProps {
  data: BreadCrumb[];
}

function BreadCrumbs({ data }: BreadcrumbsProps) {
  const { setBreadcrumbs } = useBreadcrumbContext();
  const prevKeyRef = useRef<string>('');

  // stable non-reactive key generator to compare arrays cheaply
  const computeKey = useEffectEvent((arr: BreadCrumb[]) =>
    arr.map((b) => `${b.label}|${b.path ?? ''}`).join('>'),
  );

  useEffect(() => {
    const nextKey = computeKey(data);
    if (nextKey !== prevKeyRef.current) {
      prevKeyRef.current = nextKey;
      startTransition(() => setBreadcrumbs(data));
    }
  }, [data, setBreadcrumbs]);

  return null;
}

export default BreadCrumbs;
